<template>
  <div class="content">
    <div class="list" v-if="list.length > 0">
      <div v-for="(it, index) in list" :key="index" class="list_item">
        <div class="title_img">
          <div class="img_box">Part{{ index + 1 }}</div>
        </div>
        <div
          class="content_info"
          v-for="item in it"
          :key="item && item.id"
          @click="handleDialogUnlock(item)"
        >
          <template v-if="item && item.docuCourseCase">
            <div class="info">
              <div class="name" v-if="item && item.docuCourseCase.title">
                {{ item.docuCourseCase.title }}
              </div>
              <div class="teacher" v-if="item && item.docuCourseCase.keynoteSpeaker">
                作者：{{ item.docuCourseCase.keynoteSpeaker }}
              </div>
              <div
                class="item-unlock"
                v-if="
                  `${item.docuCourseCase.isUnlock}` === '1' &&
                    !item.docuCourseCase.myUnlock
                "
              >
                <img
                  src="@/assets/images/data-base/unlock.png"
                  class="icon-unlock"
                  alt=""
                />
                <span class="txt"
                  >{{ item && item.docuCourseCase.unlockCost }}积分解锁</span
                >
              </div>
            </div>
            <div class="img_box">
              <img class="img" :src="item && item.docuCourseCase.coverUrl" alt="" />
              <div class="type">{{ contentType[item.type] }}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="empty-block" v-else-if="isNone">
      <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
      <div class="empty-txt">暂无内容</div>
    </div>
    <dialog-unlock
      ref="dialogUnlock"
      @unlockSuccess="handleJump"
      :dataProps="dataProps"
    ></dialog-unlock>
  </div>
</template>

<script>
import { contentType } from '../data'
// import { contentType, rolesClick } from '../data'
import { getDcc } from '@/api/student'
import { setSha, traceClickURL } from '../../../utils/util'
import dialogUnlock from '@/components/dialogUnlock.vue'
import {isScorm} from '../../../api/scorm'
export default {
  components: {
    dialogUnlock
  },
  props: {
    areaId: '',
    roles: {}
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  data() {
    return {
      contentType,
      list: [],
      isNone: false,
      rolesData: {},
      dataDetails: {},
      dataProps: {
        unlockContent: '兑换EP公开课课程',
        unlockTxt: '课程'
      }
    }
  },
  watch: {
    roles(newval, old) {
      this.rolesData = newval
    }
  },
  mounted() {
    if (this.roles && Object.keys(this.roles).length > 0) {
      this.rolesData = this.roles
    }
    this.handleGetPostList()
  },
  methods: {
    handleGetPostList() {
      let params = {
        areaId: this.areaId
      }
      getDcc(params)
        .then(res => {
          this.$toast.clear()
          if (res) {
            for (let key in res.data) {
              this.list.push(res.data[key])
            }
            if (this.list.length === 0) {
              this.isNone = true
            }
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
    },
    handleDialogUnlock(item) {
      this.dataDetails = item.docuCourseCase
      if (
        `${item.docuCourseCase.isUnlock}` === '1' &&
        !item.docuCourseCase.myUnlock
      ) {
        this.dataProps.baseId = item.docuCourseCase.baseId
        this.dataProps.unlockCost = item.docuCourseCase.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleJump()
    },
    async handleJump() {
      let item = this.dataDetails
      window.sessionStorage.setItem('entrance', '53')
      let trackParams = `&entrance=53&businessChannel=53&campId=${this.$route.query.areaId}`
      let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      if (item.type === 1) {
        this.$router.push({
          path: '/articleDetails',
          query: {
            id: item.baseId,
            entrance: '53',
            channel: 53,
            areaId: this.$route.query.areaId,
            businessId: this.$route.query.areaId,
          }
        })
      } else if (item.type === 3) {
        setTimeout(() => {
          traceClickURL()
        })
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.baseId}${openidBindli}${trackParams}`
      } else if (item.type === 2) {
        const query = {
          courseId: item.baseId,
          sectionId: item.sectionId,
          areaId: this.$route.query.areaId,
          businessId: this.$route.query.areaId,
          entrance: '53',
          channel: '53'
        }
        const isscorm = await isScorm(item.baseId)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.$router.push({path, query})
      }
    }
  },
  beforeRouterEnter(to, from, next) {
    next(vm => {
      vm.handleGetPostList()
    })
  }
}
</script>

<style scoped lang="less">
.content {
  min-height: calc(100vh - 260px);
  background: linear-gradient(180deg, #f6f8fa 6%, #edf1f4 8%, #f2f7fa 100%);
}
.list {
  padding: 10px 16px;
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    #f6f8fa 0%,
    #f6f8fa 6%,
    #f6f8fa 8%,
    #f6f8fa 100%
  );
  &_item {
    width: 343px;
    min-height: 101px;
    margin-bottom: 8px;
    background-color: #fff;
    border-radius: 0 0 12px 12px;
    box-sizing: border-box;
    .title_img {
      width: 343px;
      height: 20px;
      .img_box {
        width: 60px;
        height: 20px;
        background: url("../../../assets/student/week.png") no-repeat;
        background-size: 100% 100%;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 600;
        font-size: 12px;
        color: #ffffff;
        line-height: 20px;
        text-align: center;
      }
    }
    .content_info {
      width: 343px;
      min-height: 80px;
      padding: 6px 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        padding: 10px 0;
        box-sizing: border-box;
        max-width: 210px;
        .name {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 14px;
          color: #000000;
          margin-bottom: 6px;
          height: 40px;
          line-height: 20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .teacher {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 14px;
          color: #7a8494;
        }
      }

      .img_box {
        width: 103px;
        height: 68px;
        position: relative;
        .img {
          width: 103px;
          height: 68px;
          border-radius: 4px;
        }
        .type {
          width: 31px;
          height: 16px;
          background: rgba(255, 255, 255, 0.8);
          position: absolute;
          bottom: 0;
          left: 0;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 12px;
          color: #000000;
          text-align: center;
          line-height: 16px;
          border-radius: 0px 8px 0px 0px;
        }
      }
    }
  }
}
.item-unlock {
  display: flex;
  align-items: center;
  height: 20px;
  margin-top: 2px;

  .icon-unlock {
    width: 10px;
    margin-right: 4px;
    display: block;
  }

  .txt {
    color: #EB1700;
    font-size: 12px;
  }
}
.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 60px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/compontents/studyContent.vue